"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteMoistureLoadFilesMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.deleteMoistureLoadFilesMutation = (0, graphql_tag_1.default) `
  mutation DeleteMoistureLoadFiles($moistureLoadFileIds: [ID!]!) {
    deleteMoistureLoadFiles(moistureLoadFileIds: $moistureLoadFileIds) {
      errorMessage
      deletionSuccessful
    }
  }
`;
//# sourceMappingURL=delete-moisture-load-files.js.map